var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagNiue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0038 16 0.00175 16 0C24.8365 0 32 7.1635 32 16Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 7.6521V13.0485L10.4344 7.6521H15.9996Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34779 15.9999H13.0485L8.34779 9.73901L7.65216 14.6086L8.34779 15.9999Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9572 16.0001H16C16 15.9857 16 15.9717 16 15.9573C15.9858 15.9716 15.9715 15.9858 15.9572 16.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34781C16 5.5325 16 3.68781 16 0H15.9973C7.16194 0.0015 0 7.16431 0 16H8.34781V11.2993L13.0485 16H15.9572C15.9715 15.9858 15.9858 15.9715 16.0001 15.9572C16.0001 14.8793 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.0325L10.3153 8.3479H8.34778V8.34803L15.9998 16H16C16 16 16 14.6433 16 14.0325Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09466 2.08691C7.47785 2.43816 6.88691 2.8296 6.32491 3.25691H6.98141L5.24629 4.51779L5.90891 6.5576L4.17379 5.29698L3.98916 5.43116C3.26873 6.24929 2.62998 7.14104 2.08691 8.09466V16H6.26085V6.26098V6.26085H16C16 4.94441 16 3.69029 16 2.08691H8.09466Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83533 2.88452C6.66277 3.00533 6.49264 3.12952 6.32508 3.25696L5.24664 4.51783L4.17414 5.29696L3.98795 5.43221C3.59508 5.87846 3.22664 6.34671 2.88477 6.83502C3.27445 7.02415 3.71189 7.13046 4.17414 7.13046C5.80702 7.13046 7.13064 5.80683 7.13064 4.17396C7.13077 3.71158 7.02452 3.27427 6.83533 2.88452Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98737 5.43233L4.17355 5.29708L5.90868 6.55777L5.24599 4.51796L6.98099 3.25708H6.32437C5.47474 3.90327 4.6918 4.63227 3.98737 5.43233Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0589 2.78271L11.4043 3.84553H12.5218L11.6177 4.50247L11.9629 5.56528L11.0589 4.9084L10.1548 5.56528L10.4999 4.50247L9.59589 3.84553H10.7134L11.0589 2.78271Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17394 9.73926L4.51931 10.8021H5.63681L4.73281 11.4591L5.078 12.5219L4.17394 11.8649L3.26981 12.5219L3.615 11.4591L2.711 10.8021H3.8285L4.17394 9.73926Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagNiue);
export default __webpack_public_path__ + "static/media/flag_niue.b4a0d81ae799c82cc58c41a06fd106d6.svg";
export { ForwardRef as ReactComponent };